import { isValidElement } from "react";
import NumberKeyboardKey from "./number-keyboard-key.js";
export function isNumberKeyboardKeyElement(node) {
    return isValidElement(node) && node.type === NumberKeyboardKey;
}
